/**
 * Funcion que retorna las dos primeras letras en base al nombre y apellido de una persona para el avatar toma en
 * cuenta que el nombre sea NOMBRE APELLIDO o NOMBRES APELLIDOS
 */

const generateAvatarLetters = (userNames = "") => {
  if (typeof userNames !== "string" || !userNames.trim()) return "";

  const names = userNames.trim().split(/\s+/).filter(Boolean);
  
  if (names.length === 0) return "";

  if (names.length === 1) return names[0][0].toUpperCase();

  const first = names[0][0]?.toUpperCase() || "";
  const last = names[names.length - 1][0]?.toUpperCase() || "";

  return `${first}${last}`;
};

export default generateAvatarLetters;
